import { openModal } from '@core/components/ModalStack';
import { EmailPreviewModalProps } from './EmailPreviewModal';

export async function openEmailPreviewModal(props: EmailPreviewModalProps) {
  const { EmailPreviewModal } = await import('./EmailPreviewModal');

  openModal(EmailPreviewModal, props);
}
